import React from "react";
import Modal from "../Modal/Modal";
import Button from "../Button/Button";
import styles from "./ConfirmLogoutModal.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setModalOpen, clear } from "@/store/slices/globalSlice";
import { clear as clearUser } from "@/store/slices/userSlice";
import { MODAL_ID } from "@/lib/constants";
import { clearOnLogout } from "@/lib/utils";
import routes from "@/routes/routes";
import { type RootState } from "@/store/rootReducer";
import logoutIcon from "@/assets/svg/Other/Logout";

const ConfirmLogoutModal: React.FC = () => {
  const { modalOpen } = useSelector((state: RootState) => state.global);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const closeModal = () => {
    dispatch(setModalOpen({ id: null, data: null }));
  };

  const handleLogoutConfirm = () => {
    clearOnLogout();
    dispatch(clear());
    dispatch(clearUser());
    closeModal();
    window.location.href = routes?.publicRoutes?.LOGIN?.path ?? "/login";
  };

  return (
    <Modal
      heading="Confirm Logout"
      modalOpen={modalOpen.id === MODAL_ID.LOGOUT}
      closeModal={closeModal}
    >
      <div className={styles.iconContainer}>
        {logoutIcon()}
      </div>
      <h3>Are you sure you want to log out?</h3>
      <div className={styles.buttonContainer}>
        <Button className={styles.cancelButton} onClick={closeModal}>
          Cancel
        </Button>
        <Button className={styles.logoutConfirmBtn} onClick={handleLogoutConfirm}>
          Logout
        </Button>
      </div>
    </Modal>
  );
};

export default ConfirmLogoutModal;
